import type { UITree } from '@json-render/core'

/**
 * Chat interface layout manifest.
 *
 * MessageList handles both the empty state (no session selected)
 * and the active session (showing messages). Route changes update
 * currentSessionIdAtom via useChatRouteSync — no outlet needed.
 */
export const chatManifest: UITree = {
  root: 'root',
  elements: {
    'root': {
      key: 'root',
      type: 'chatbot-layout',
      props: {},
      children: ['sidebar', 'main'],
    },
    'sidebar': {
      key: 'sidebar',
      type: 'sidebar',
      props: { title: 'Robolab X' },
      children: ['session-list', 'sidebar-footer'],
      parentKey: 'root',
    },
    'session-list': {
      key: 'session-list',
      type: 'session-list',
      props: {},
      parentKey: 'sidebar',
    },
    'sidebar-footer': {
      key: 'sidebar-footer',
      type: 'sidebar-footer',
      props: {},
      parentKey: 'sidebar',
    },
    'main': {
      key: 'main',
      type: 'chat-panel',
      props: {},
      children: ['chat-header', 'message-list', 'chat-input'],
      parentKey: 'root',
    },
    'chat-header': {
      key: 'chat-header',
      type: 'chat-header',
      props: {},
      parentKey: 'main',
    },
    'message-list': {
      key: 'message-list',
      type: 'message-list',
      props: {},
      parentKey: 'main',
    },
    'chat-input': {
      key: 'chat-input',
      type: 'chat-input',
      props: { placeholder: 'Ask me anything...' },
      parentKey: 'main',
    },
  },
}

/**
 * Admin interface layout manifest.
 *
 * AdminLayout renders AdminSidebar + React Router <Outlet />.
 * The Outlet is populated by nested admin routes in App.tsx.
 */
export const adminManifest: UITree = {
  root: 'admin-root',
  elements: {
    'admin-root': {
      key: 'admin-root',
      type: 'admin-layout',
      props: {},
    },
  },
}
